import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Slide5 from "./preview/slide-5.png";
import Avatar from "./basic-16-avatar.png";
import BgOption1 from "./../images/bg-option-1.png";
import BgOption2 from "./../images/bg-option-2.png";
import BgOption3 from "./../images/bg-option-3.png";
import TemplateImage from "./template-image.png";
import BaseTemplate from "../base";
import { MultilineView, TextView } from "../../components";

class Basic16 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #16";
    this.id = "16";
    this.url = "/ai/carousels/basic-16";
    this.description = "Create a carousel of images";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Jon Snow",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Avatar,
          },
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#84D65B",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },
        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "secondary",
          value: "#FFFFFF",
        },
        {
          label: "Secondary Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "teritary",
          value: "#000000",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Big Shoulders Display",
          type: "font",
        },
        {
          label: "Secondary Font",
          key: "secondary_font",
          value: "Instrument Sans",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4, Slide5];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "6 Ways To Gain Customer Trust",
            max_words: 8,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: TemplateImage,
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Why is customer trust important?",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "30px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id es`,
            max_words: 15,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: TemplateImage,
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Create Strong Relationships With Customers",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "30px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, to`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: TemplateImage,
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Help Customers Solve Problems",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "30px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur ma`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: TemplateImage,
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "SHARE YOUR THOUGHTS IN the COMMENTS",
            max_words: 3,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getBackgroundColor(commonSettings) {
    return commonSettings.elements[2].value.color;
  }

  getPrimaryColor(commonSettings) {
    return commonSettings.elements[3]?.value;
  }

  getSecondaryColor(commonSettings) {
    return commonSettings.elements[4]?.value;
  }

  getPrimaryFont(commonSettings) {
    return commonSettings.elements[5]?.value || "Big Shoulders Display";
  }

  getSecondaryFont(commonSettings) {
    return commonSettings.elements[6]?.value || "Instrument Sans";
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    if (index === 0) {
      let el = {
        label: "Description",
        target_key: "description",
        value: "",
      };
      new_slide.elements.push(el);
    }

    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderIntroSlide(slide, index, currentSlide, carouselLength, commonSettings) {
    return (
      <>
        <div
          className="w-[320px] rounded-[24px] overflow-hidden"
          style={{
            backgroundColor: this.getBackgroundColor(commonSettings),
            color: this.getPrimaryColor(commonSettings),
          }}
        >
          <div className="w-full py-[32px] px-[24px] flex flex-col gap-[12px]">
            <p className="text-[18px] leading-[28px] font-semibold">
              {commonSettings.elements[0].value}
            </p>
            <div
              className="text-[48px] leading-[48px] font-bold uppercase"
              style={{
                fontFamily: this.getPrimaryFont(commonSettings),
              }}
            >
              {slide.elements[0]?.style ? (
                <MultilineView
                  element={slide.elements[0]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[0]?.value} />
              )}
            </div>
          </div>
          {slide.elements[1]?.value && (
            <img
              className="object-cover w-full h-[166px] rounded-[24px] ring-1 ring-black/10 shrink-0"
              src={slide.elements[1].value}
              alt=""
            />
          )}
        </div>
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings
  ) {
    return (
      <>
        <div
          className="w-[320px] rounded-[24px] overflow-hidden"
          style={{
            backgroundColor: this.getSecondaryColor(commonSettings),
            color: this.getPrimaryColor(commonSettings),
          }}
        >
          <div className="w-full py-[32px] px-[24px] flex flex-col gap-[12px]">
            <p
              className="text-[30px] leading-[30px] font-bold uppercase"
              style={{
                fontFamily: this.getPrimaryFont(commonSettings),
              }}
            >
              {slide.elements[0]?.style ? (
                <MultilineView
                  element={slide.elements[0]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[0]?.value} />
              )}
            </p>
            <p className="text-[14px] leading-[20px] font-normal">
              {slide.elements[1]?.style ? (
                <MultilineView
                  element={slide.elements[1]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[1]?.value} />
              )}
            </p>
          </div>
          {slide.elements[2]?.value && (
            <img
              className="object-cover w-full h-[166px] rounded-[24px] ring-1 ring-black/10 shrink-0"
              src={slide.elements[2]?.value}
              alt=""
            />
          )}
        </div>
      </>
    );
  }

  renderOutroSlide(slide, index, currentSlide, carouselLength, commonSettings) {
    return (
      <>
        <div
          className="w-[320px] rounded-[24px] overflow-hidden"
          style={{
            backgroundColor: this.getBackgroundColor(commonSettings),
            color: this.getSecondaryColor(commonSettings),
          }}
        >
          <div className="w-full py-[32px] px-[24px] flex flex-col gap-[24px]">
            <div className="flex flex-col gap-[12px]">
              <img
                className="object-cover w-[96px] h-[96px] rounded-full"
                src={commonSettings.elements[1]?.value.image || LogoPlaceholder}
                alt=""
              />
              <p className="text-[18px] leading-[28px] font-semibold">
                {commonSettings.elements[0].value}
              </p>
            </div>
            <p
              className="text-[48px] leading-[48px] font-bold uppercase"
              style={{
                fontFamily: this.getPrimaryFont(commonSettings),
              }}
            >
              {slide.elements[0]?.style ? (
                <MultilineView
                  element={slide.elements[0]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[0]?.value} />
              )}
            </p>
            <svg
              width="97"
              height="20"
              viewBox="0 0 97 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 10.2715C19.9397 12.8956 18.89 15.3646 16.7644 17.3557C15.7925 18.2662 14.6695 18.9393 13.4193 19.3929C12.0507 19.8904 10.5899 20.0826 9.1393 19.9559C7.68869 19.8292 6.2833 19.3867 5.02156 18.6595C4.92447 18.6036 4.846 18.6213 4.75437 18.6548C3.57485 19.0849 2.39532 19.5167 1.21407 19.9408C0.863685 20.0665 0.540869 19.9904 0.276656 19.7286C0.00871841 19.463 -0.0672676 19.1375 0.060369 18.7815C0.489467 17.5835 0.923034 16.3871 1.36107 15.1924C1.37514 15.1587 1.38069 15.1221 1.37723 15.0857C1.37376 15.0494 1.36139 15.0144 1.34121 14.984C0.912669 14.2471 0.582648 13.457 0.359595 12.6342C0.0714628 11.591 -0.0428892 10.5074 0.0211344 9.42699C0.151585 7.27478 0.89398 5.36025 2.24832 3.68341C3.33422 2.34179 4.68831 1.35223 6.29222 0.712482C7.66774 0.160784 9.14935 -0.075481 10.6281 0.021055C14.4555 0.256582 17.8163 2.67595 19.2632 6.24166C19.7514 7.44389 19.9898 8.69681 20 10.2715Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M55.2253 0.45459C52.1855 0.45459 50.5003 2.62897 50.5003 2.62897C50.5003 2.62897 48.815 0.45459 45.7753 0.45459C42.5854 0.45459 40.0002 3.01598 40.0002 6.17663C40.0002 10.516 45.1579 14.7212 46.5953 16.0498C48.2512 17.5791 50.5003 19.5454 50.5003 19.5454C50.5003 19.5454 52.7494 17.5791 54.4052 16.0498C55.8427 14.7212 61.0003 10.516 61.0003 6.17663C61.0003 3.01598 58.4152 0.45459 55.2253 0.45459Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
              <path
                d="M96.2734 18.4153C96.2734 18.8843 95.7403 19.1543 95.3622 18.8769L88.9757 14.1911C88.7742 14.0433 88.4999 14.0433 88.2984 14.1911L81.9119 18.8769C81.5338 19.1543 81.0007 18.8843 81.0007 18.4153V1.0271C81.0007 0.710912 81.2571 0.45459 81.5732 0.45459H95.7009C96.0171 0.45459 96.2734 0.710912 96.2734 1.0271V18.4153Z"
                fill={this.getSecondaryColor(commonSettings)}
              />
            </svg>
          </div>
        </div>
      </>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getSecondaryFont(commonSettings),
        }}
      >
        <div className="absolute inset-0">
          {commonSettings.elements[2].value.type === "image" &&
            commonSettings.elements[2].value.image && (
              <img
                className="object-cover w-full h-full"
                src={commonSettings.elements[2].value.image}
                alt=""
              />
            )}
          {commonSettings.elements[2].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor:
                  index === 0 || index === carouselLength - 1
                    ? this.getSecondaryColor(commonSettings)
                    : this.getBackgroundColor(commonSettings),
              }}
            >
              {(index === 0 || index === carouselLength - 1) && (
                <svg
                  width="400"
                  height="500"
                  viewBox="0 0 400 500"
                  fill="#ffffff"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <g opacity="0.35">
                    <rect
                      width="400"
                      height="500"
                      fill={"url(#pattern0" + index + ")"}
                    />
                  </g>
                  <defs>
                    <pattern
                      id={"pattern0" + index}
                      patternContentUnits="objectBoundingBox"
                      width="0.03"
                      height="0.024"
                    >
                      <use
                        xlinkHref="#image0_1369_185"
                        transform="scale(0.0025 0.002)"
                      />
                    </pattern>
                    <image
                      id="image0_1369_185"
                      width="12"
                      height="12"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAElJREFUKBWVzVkKACAIRVFt/3s2DYoGh5fg37nKRCS60IgINUgqMszMWDCxHS8/7LgMbpwGHg6DCLtBhp+gwkeA4BWgeAQ/2IIOyTslFP70JE8AAAAASUVORK5CYII="
                    />
                  </defs>
                </svg>
              )}
            </div>
          )}
        </div>
        <div className="absolute w-full h-full flex items-center justify-center">
          {index === 0 &&
            this.renderIntroSlide(
              slide,
              index,
              currentSlide,
              carouselLength,
              commonSettings
            )}
          {index === carouselLength - 1 &&
            this.renderOutroSlide(
              slide,
              index,
              currentSlide,
              carouselLength,
              commonSettings
            )}
          {index !== 0 &&
            index !== carouselLength - 1 &&
            this.renderMiddleSlide(
              slide,
              index,
              currentSlide,
              carouselLength,
              commonSettings
            )}
        </div>
      </div>
    );
  }
}

export default Basic16;
